import {
  IFormFieldOptions,
  IIntake,
  IMilestoneApprover,
  INotificationRole,
  IProjectRole,
} from "@/interfaces";

export const filterRegionAndFunctionalArea = (
  roles: IProjectRole[],
  intake: IIntake | undefined,
  currentRole: IMilestoneApprover | INotificationRole
): { regions: IFormFieldOptions; functionalAreas: IFormFieldOptions } => {
  const filteredRegionOptions: IFormFieldOptions = {};
  const filteredFunctionalAreaOptions: IFormFieldOptions = {};
  const role = roles.find(
    ({ id }: { id: string }) => id === currentRole.roleId
  );
  role?.regionalProjectRoles?.forEach(
    ({
      region,
      functionalArea,
    }: {
      region: string;
      functionalArea: string;
    }) => {
      filteredRegionOptions[region] = {
        id: intake?.region[region].id ?? "",
        fallback: intake?.region[region].fallback ?? "",
      };

      if (currentRole.region === undefined || currentRole.region === region) {
        filteredFunctionalAreaOptions[functionalArea] = {
          id: intake?.functionalArea[functionalArea].id ?? "",
          fallback: intake?.functionalArea[functionalArea].fallback ?? "",
        };
      }
    }
  );

  return {
    regions: filteredRegionOptions,
    functionalAreas: filteredFunctionalAreaOptions,
  };
};
